import { render, staticRenderFns } from "./dynamic-route.vue?vue&type=template&id=aa097f6e&"
import script from "./dynamic-route.vue?vue&type=script&lang=ts&"
export * from "./dynamic-route.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports